export default __webpack_public_path__ + "static/media/accept_payment.d87d0950.svg";